<template>
    <div>
        <b-card v-show="editMode===0">
            <b-row>
                <b-col sm="12" class="text-right">
                    <b-btn-group size="sm">
                        <b-button variant="white" class="button-icon-only mr-1" title="Обновить"
                                  @click="buttonRefreshClicked"
                        >
                            <i class="fa fa-sync"/>
                        </b-button>
                        <b-button class="d-none" v-show="userActionAccessArray['new']" variant="success"
                                  @click="buttonAddClicked">
                            <i class="fa fa-plus"/> Новая запись
                        </b-button>
                        <b-dropdown right text="Новая запись" variant="success">
                            <b-dropdown-item @click="editMode=1">Бытовой 1-ф</b-dropdown-item>
                            <b-dropdown-item @click="editMode=1">Бытовой 3-ф до 10кВт</b-dropdown-item>
                            <b-dropdown-item @click="editMode=1">Бытовой 3-ф свыше 10кВт</b-dropdown-item>
                        </b-dropdown>
                    </b-btn-group>
                </b-col>
            </b-row>
            <MyToolbar>
                <MyToolbarItem>
                    <b-input v-model="searchQuickFilter" @keyup.prevent.enter="buttonSearchClicked" maxlength="200"
                             size="sm" placeholder="Поиск..." ref="inputQuickFilter" @keyup.esc="searchQuickFilter=''"
                             :disabled="sortMode!==0"
                    />
                </MyToolbarItem>
                <MyToolbarItem>
                    <b-input-group>
                        <b-input-group-prepend>
                            <label for="input-start-dt" class="mt-2">Дата:</label>
                        </b-input-group-prepend>
                        <b-input id="input-start-dt" v-model="searchStartDt" @change="buttonSearchClicked"
                                 :disabled="sortMode!==0"
                                 style="margin-left:10px;width:140px" size="sm" type="date"
                        />
                    </b-input-group>
                </MyToolbarItem>
                <MyToolbarItem>
                    <b-button size="sm" variant="secondary" @click="buttonSearchClicked">Поиск</b-button>
                    <b-button size="sm" :variant="sortMode===0 ? 'secondary' : 'primary'" title="Расширенный поиск"
                              class="button-icon-only-normal ml-2"
                              @click="buttonAdvSearchShowClicked"
                    >
                        <i class="fas fa-cog"/>
                    </b-button>
                </MyToolbarItem>
            </MyToolbar>

            <b-alert :show="err" :variant="errVariant" class="mb-4">{{errText}}</b-alert>

            <b-table outlined hover head-variant="light" :fields="subscriberListFields" :items="subscriberList"
                     responsive="responsive" :no-local-sorting="true" sort-by="DT" sort-desc
                     @row-clicked="tableRowClicked"
                     @sort-changed="sortChanged"
            >
            </b-table>
            <b-row>
                <b-col sm="6">
                    <b-pagination first-number last-number
                                  v-model="recordCurrentPageNumber" @input="loadRegistrationList"
                                  :total-rows="recordTotalNumber" :per-page="recordCountPerPage"
                    />
                </b-col>
                <b-col sm="6">
                    <div class="custom-items-per-page-div">
                        <label>Показать записей:</label>
                        <b-form-select id="input-records-per-page" size="sm" style="margin-left: 10px;width:65px"
                                       :options="recordCountPerPageArray" v-model="recordCountPerPage"
                                       @change="loadRegistrationList"
                        />
                    </div>
                </b-col>
            </b-row>

        </b-card>
        <b-card v-show="editMode===1" title="Добавление записи">
            <div class="step-tab-container">
                <div :class="activeTabIndex===0 ? 'step-tab-item active' : 'step-tab-item'" @click="activeTabIndex=0">
                    <div class="step-tab-item-label">
                        <h3><span>1</span>Данные заявки</h3>
                        <div class="step-tab-item-bar"></div>
                    </div>
                </div>
                <div :class="activeTabIndex===1 ? 'step-tab-item active' : 'step-tab-item'" @click="activeTabIndex=1">
                    <div class="step-tab-item-label">
                        <h3><span>2</span>Заявка у зам.начальника РЭС</h3>
                        <div class="step-tab-item-bar"></div>
                    </div>
                </div>
                <div :class="activeTabIndex===3 ? 'step-tab-item active' : 'step-tab-item'" @click="activeTabIndex=3">
                    <div class="step-tab-item-label">
                        <h3><span>3</span>Заявка у начальника участка</h3>
                        <div class="step-tab-item-bar"></div>
                    </div>
                </div>
                <div :class="activeTabIndex===4 ? 'step-tab-item active' : 'step-tab-item'" @click="activeTabIndex=4">
                    <div class="step-tab-item-label">
                        <h3><span>4</span>Заявка у начальника</h3>
                        <div class="step-tab-item-bar"></div>
                    </div>
                </div>
                <div :class="activeTabIndex===5 ? 'step-tab-item active' : 'step-tab-item'" @click="activeTabIndex=5">
                    <div class="step-tab-item-label">
                        <h3><span>5</span>Заявка у начальника</h3>
                        <div class="step-tab-item-bar"></div>
                    </div>
                </div>
                <div :class="activeTabIndex===6 ? 'step-tab-item active' : 'step-tab-item'" @click="activeTabIndex=6">
                    <div class="step-tab-item-label">
                        <h3><span>6</span>Заявка у начальника</h3>
                        <div class="step-tab-item-bar"></div>
                    </div>
                </div>
                <div :class="activeTabIndex===7 ? 'step-tab-item active' : 'step-tab-item'" @click="activeTabIndex=7">
                    <div class="step-tab-item-label">
                        <h3><span>7</span>Заявка у начальника</h3>
                        <div class="step-tab-item-bar"></div>
                    </div>
                </div>
                <div :class="activeTabIndex===8 ? 'step-tab-item active' : 'step-tab-item'" @click="activeTabIndex=8">
                    <div class="step-tab-item-label">
                        <h3><span>8</span>Заявка у начальника</h3>
                        <div class="step-tab-item-bar"></div>
                    </div>
                </div>
                <div :class="activeTabIndex===9 ? 'step-tab-item active' : 'step-tab-item'" @click="activeTabIndex=9">
                    <div class="step-tab-item-label">
                        <h3><span>9</span>Заявка у начальника</h3>
                        <div class="step-tab-item-bar"></div>
                    </div>
                </div>
            </div>

            <div v-show="activeTabIndex===0">
                <b-row>
                    <b-col md="6">
                        <b-form-group label="Заявитель" label-for="input-edit-subscriber" class="required">
                            <b-input id="input-edit-subscriber" v-model="editSubscriber" @keyup.esc="cancelRecord"
                                     maxlength="200" ref="inputEditSubscriber"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <b-form-group label="Телефон(ы)" label-for="input-edit-phone-numbers" class="required">
                            <b-input id="input-edit-phone-numbers" v-model="editPhoneNumbers" @keyup.esc="cancelRecord"
                                     maxlength="40"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="12">
                        <b-form-group label="Адрес" label-for="input-edit-address" class="required">
                            <b-input id="input-edit-address" v-model="editAddress" @keyup.esc="cancelRecord"
                                     maxlength="200"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="12">
                        <b-form-group label="Примечание" label-for="textarea-edit-description">
                            <b-textarea id="textarea-edit-description" v-model="editDescription" rows="2"
                                        maxlength="200"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
            </div>

            <div v-show="activeTabIndex===1">
                <b-row>
                    <b-col md="6">
                        <b-form-group label="Данные1">
                            <b-input/>
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <b-form-group label="Данные2">
                            <b-input/>
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <b-form-group label="Данные3">
                            <b-input/>
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <b-form-group label="Данные4">
                            <b-input/>
                        </b-form-group>
                    </b-col>
                </b-row>
            </div>

            <div v-show="activeTabIndex===2">
                <b-row>
                    <b-col md="12">
                        <b-form-group label="Адрес">
                            <b-input/>
                        </b-form-group>
                    </b-col>
                    <b-col md="12">
                        <b-form-group label="Описание">
                            <b-input/>
                        </b-form-group>
                    </b-col>
                </b-row>
            </div>

            <div class="mt-3">
                <b-button class="mt-2" variant="primary">
                    Сохранить
                </b-button>
                <b-button @click="editMode=0" variant="secondary" class="ml-2 mt-2 mr-5">
                    Закрыть
                </b-button>

                <b-button variant="secondary" class="mt-2" title="Печатать бланк"
                          :disabled="editDocBlankUid===-1" @click="generateBlank('kg')"
                >
                    <i class="fa fa-print"/> Бланк кырг.
                </b-button>
                <b-button variant="secondary" class="ml-2 mt-2" title="Печатать бланк"
                          :disabled="editDocBlankUid===-1" @click="generateBlank('ru')"
                >
                    <i class="fa fa-print"/> Бланк рус.
                </b-button>

            </div>

        </b-card>

    </div>
</template>

<script>
    import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
    import MyToolbar from "@/view/components/MyToolbar";
    import MyToolbarItem from "@/view/components/MyToolbarItem";
    import axios from "axios";

    export default {
        name: "NewSubscriber1",
        components: {MyToolbar, MyToolbarItem},
        data() {
            return {
                userData: this.$store.getters.getUserData,
                recordCountPerPageArray: this.$store.getters.getRecordCountPerPageArray || [],
                recordCountPerPage: this.$store.getters.getRecordCountPerPage || 20,
                recordCurrentPageNumber: 1,
                recordTotalNumber: 0,

                userActionAccessArray: [],
                userActionAccessCompany: false,
                userActionAccessRes: false,

                activeTabIndex: 0,

                loadProcessing: 0,

                editMode: 0,    //0-список записей, 1-добавление/редактирование
                addEditTitle: "",
                recordUid: "",
                recordVersion: "",

                err: false,
                errText: "",
                errVariant: "danger",

                errModal: false,
                errTextModal: "",
                errVariantModal: "danger",

                editRecordSavedMessageTimer: null,
                editRecordSavedMessage: "",

                searchQuickFilter: "",
                searchRegistrationStatusUid: -1,
                searchCompanyUid: 0,
                searchResUid: "",
                searchStartDt: new Date().toISOString().substr(0, 10),
                searchEndDt: new Date().toISOString().substr(0, 10),
                searchRegistrationNum: "",
                searchRegistrationTypeUid: -1,
                searchSubscriber: "",
                searchPhoneNumber: "",
                searchAddress: "",

                sortMode: 0,    //0-simple, 1-advanced
                sortBy: "DT",
                sortDesc: true,

                searchRegistrationStatuses: [],
                searchCompanies: [],
                searchRes: [{'value': '', 'text': '<все>'}],
                searchRegistrationTypes: [],

                subscriberList: [],
                subscriberListFields: [
                    {key: "RowNumber", label: "№", tdClass: "pointer"},
                    {key: "CompanyAlias", label: "РЭК", sortable: true, tdClass: "pointer"},
                    {key: "RES", label: "РЭС", sortable: true, tdClass: "pointer"},
                    {key: "DT", label: "Дата", sortable: true, tdClass: "pointer"},
                    {key: "RegistrationNum", label: "Номер", sortable: true, tdClass: "pointer"},
                    {key: "Subscriber", label: "Абонент", sortable: true, tdClass: "pointer"},
                    {key: "Address", label: "Адрес", tdClass: "pointer"},
                    {key: "PhoneNumbers", label: "Телефон(ы)", tdClass: "pointer"},
                    {key: "RegistrationType", label: "Вид регистрации", sortable: true, tdClass: "pointer"},
                    {key: "RegistrationStatus", label: "Статус", sortable: true, tdClass: "pointer"},
                ],

                editCompanies: [],
                editRes: [],
                editRegistrationStatuses: [],
                editRegistrationTypes: [],

                editDocBlankUid: -1,
                editCompanyUid: 0,
                editResUid: "",
                editRegistrationTypeUid: -1,
                editSubscriber: "",
                editAddress: "",
                editPhoneNumbers: "",
                editDescription: "",
                editRegistrationStatusUid: 0,
                editRegistrationStepUid: 0,

                attachments: [
                    {
                        FileName: "passport1",
                        Attachment: "Паспорт лицевая сторона",
                    },
                    {
                        FileName: "passport2",
                        Attachment: "Паспорт обратная сторона",
                    },
                    {
                        FileName: "techdoc",
                        Attachment: "Тех док.",

                    }
                ],
                fileDownloadCounter: 0
            }
        },

        created() {

        },
        mounted() {
            this.$store.dispatch(SET_BREADCRUMB, [
                {title: "Документы", route: "new-subscriber"},
                {title: "Новый абонент"}
            ]);
        },
        methods: {
            errTextHide() {
                this.err = false
                this.errText = ""
            },
            errTextShow(msg, variant = "danger", withScroll = true) {
                if (withScroll)
                    window.scrollTo(0, 0)
                this.errText = msg
                this.errVariant = variant
                this.err = true
            },
            errTextHideModal() {
                this.errModal = false
                this.errTextModal = ""
            },
            errTextShowModal(msg, variant = "danger", withScroll = true) {
                if (withScroll)
                    window.scrollTo(0, 0)
                this.errTextModal = msg
                this.errVariantModal = variant
                this.errModal = true
            },
            loadCompanies() {
                this.editCompanies = []
                this.searchCompanies = [{'value': 0, 'text': "<все>"}]

                axios.post("/ws/ws.svc/GetRefsCompaniesArray", {
                        'Session_UID': this.userData.Session_UID,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                            if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)
                                || this.isUndefined(resp.data.data)) {
                                this.errTextShow("Неверный формат ответа.")
                            } else {
                                if (resp.data.success) {
                                    if (resp.data.data.toString().length > 0) {
                                        let result = JSON.parse(resp.data.data)
                                        result.data.forEach(item => {
                                            this.editCompanies.push({'value': item.UID, 'text': item.Alias})
                                            this.searchCompanies.push({'value': item.UID, 'text': item.Alias})
                                        })
                                    }
                                } else {
                                    this.errTextShow(resp.data.response.toString())
                                }
                            }
                        }
                    )
                    .catch(err => {
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")")
                    })
            },
            loadSearchRes() {
                this.searchResUid = ""
                this.searchRes = [{'value': "", 'text': '<все>'}]
                this.errTextHideModal()

                if (!this.userActionAccessRes) return

                this.loadProcessing++
                axios.post("/ws/ws.svc/GetRefsRESArray", {
                        'Session_UID': this.userData.Session_UID,
                        'F_Company_UID': this.searchCompanyUid,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                            if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)
                                || this.isUndefined(resp.data.data)) {
                                this.errTextShowModal("Неверный формат ответа.")
                            } else {
                                if (resp.data.success) {
                                    if (resp.data.data.toString().length > 0) {
                                        let result = JSON.parse(resp.data.data)
                                        result.forEach(item => {
                                            this.searchRes.push({
                                                'value': item.UID,
                                                'text': item.RES
                                            })
                                        })
                                    }
                                } else {
                                    this.errTextShowModal(resp.data.response.toString())
                                }
                            }
                            this.loadProcessing--
                        }
                    )
                    .catch(err => {
                        this.loadProcessing--
                        this.errTextShowModal("Ошибка при получении данных (" + err.message + ")")
                    })
            },
            loadEditRes() {
                this.editRes = []
                this.errTextHideModal()

                axios.post("/ws/ws.svc/GetRefsRESArray", {
                        'Session_UID': this.userData.Session_UID,
                        'F_Company_UID': this.editCompanyUid,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                            this.editRes = []
                            if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)
                                || this.isUndefined(resp.data.data)) {
                                this.errTextShowModal("Неверный формат ответа.")
                            } else {
                                if (resp.data.success) {
                                    if (resp.data.data.toString().length > 0) {
                                        let result = JSON.parse(resp.data.data)
                                        result.forEach(item => {
                                            this.editRes.push({
                                                'value': item.UID,
                                                'text': item.RES
                                            })
                                        })
                                    }
                                } else {
                                    this.errTextShowModal(resp.data.response.toString())
                                }
                            }
                        }
                    )
                    .catch(err => {
                        this.errTextShowModal("Ошибка при получении данных (" + err.message + ")")
                    })
            },
            loadRegistrationTypes() {
                this.searchRegistrationTypeUid = -1
                this.searchRegistrationTypes = [{'value': -1, 'text': "<все>"}]
                this.editRegistrationTypeUid = -1
                this.editRegistrationTypes = []

                axios.post("/ws/ws.svc/GetRefsNewSubscriberRegistrationTypesArray", {
                        'Session_UID': this.userData.Session_UID,
                        'F_Company_UID': this.searchCompanyUid,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                            if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)
                                || this.isUndefined(resp.data.data)) {
                                this.errTextShow("Неверный формат ответа.")
                            } else {
                                if (resp.data.success) {
                                    if (resp.data.data.toString().length > 0) {
                                        let result = JSON.parse(resp.data.data)
                                        result.forEach(item => {
                                            this.searchRegistrationTypes.push({
                                                'value': item.UID,
                                                'text': item.RegistrationType
                                            })
                                            this.editRegistrationTypes.push({
                                                'value': item.UID,
                                                'text': item.RegistrationType
                                            })
                                        })
                                    }
                                } else {
                                    this.errTextShow(resp.data.response.toString())
                                }
                            }
                        }
                    )
                    .catch(err => {
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")")
                    })
            },
            loadRegistrationStatuses() {
                this.searchRegistrationStatusUid = -1
                this.searchRegistrationStatuses = [{'value': -1, 'text': "<все>"}]
                this.editRegistrationStatusUid = 0
                this.editRegistrationStatuses = []

                axios.post("/ws/ws.svc/GetRefsNewSubscriberRegistrationStatusesArray", {
                        'Session_UID': this.userData.Session_UID,
                        'F_Company_UID': this.searchCompanyUid,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                            if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)
                                || this.isUndefined(resp.data.data)) {
                                this.errTextShow("Неверный формат ответа.")
                            } else {
                                if (resp.data.success) {
                                    if (resp.data.data.toString().length > 0) {
                                        let result = JSON.parse(resp.data.data)
                                        result.forEach(item => {
                                            this.searchRegistrationStatuses.push({
                                                'value': item.UID,
                                                'text': item.Status
                                            })
                                            this.editRegistrationStatuses.push({
                                                'value': item.UID,
                                                'text': item.Status
                                            })
                                        })
                                    }
                                } else {
                                    this.errTextShow(resp.data.response.toString())
                                }
                            }
                        }
                    )
                    .catch(err => {
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")")
                    })
            },
            loadRegistrationList() {
                this.errTextHide()

                if (this.searchStartDt === "") {
                    this.errTextShow("Введите дату начала.", "info", true)
                    return
                }
                if (this.sortMode === 0) {
                    this.searchEndDt = this.searchStartDt
                }
                if (this.searchEndDt === "") {
                    this.errTextShow("Введите дату окончания.", "info", true)
                    return
                }
                if (this.searchStartDt > this.searchEndDt) {
                    this.errTextShow("Дата начала не может быть позднее даты окончания.", "info", true)
                    return
                }

                this.loadProcessing++
                axios.post("/ws/ws.svc/GetDocsNewSubscriberRegistrations", {
                        'Session_UID': this.userData.Session_UID,
                        'Page': this.recordCurrentPageNumber,
                        'RecordsPerPage': this.recordCountPerPage,
                        'SortField': this.sortBy,
                        'SortMode': (this.sortDesc ? 1 : 0),
                        'F_Company_UID': this.searchCompanyUid,
                        'F_RES_UID': this.searchResUid,
                        'F_QuickFilter': this.searchQuickFilter,
                        'F_DT1': this.getFormatDate(this.searchStartDt, "DD.MM.yyyy"),
                        'F_DT2': this.getFormatDate(this.searchEndDt, "DD.MM.yyyy"),
                        'F_RegistrationNum': this.searchRegistrationNum,
                        'F_RegistrationType_UID': this.searchRegistrationTypeUid,
                        'F_Subscriber': this.searchSubscriber,
                        'F_PhoneNumber': this.searchPhoneNumber,
                        'F_Address': this.searchAddress,
                        'F_RS': this.searchRegistrationStatusUid,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                        if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response) ||
                            this.isUndefined(resp.data.data) || this.isUndefined(resp.data.meta)) {
                            this.errTextShow("Неверный формат ответа.", "danger", true)
                        } else {
                            if (resp.data.success) {
                                if (resp.data.data.toString().length > 0) {
                                    this.subscriberList = JSON.parse(resp.data.data)
                                    if (!this.isUndefined(resp.data.meta.TotalRecordsAmount)) {
                                        this.recordTotalNumber = resp.data.meta.TotalRecordsAmount
                                    } else {
                                        this.errTextShow("Ошибка при получении общего кол-ва записей.", "danger", true)
                                    }
                                } else {
                                    this.recordTotalNumber = 0
                                    this.subscriberList = []

                                }
                            } else {
                                this.errTextShow(resp.data.response.toString(), "danger", true)
                            }
                        }
                        this.loadProcessing--
                    })
                    .catch(err => {
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")", "danger", true)
                        this.loadProcessing--
                    })
            },
            loadAttachments() {
                this.errTextHide()

                this.attachments = []

                this.loadProcessing++
                axios.post("/ws/ws.svc/GetRefsNewSubscriberRegistrationStepAttachmentsArray", {
                        'Session_UID': this.userData.Session_UID,
                        'F_Company_UID': this.searchCompanyUid,
                        'F_RegistrationType_UID': this.editRegistrationTypeUid,
                        'F_RegistrationStep_UID': this.editRegistrationStepUid,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                        if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response) ||
                            this.isUndefined(resp.data.data)) {
                            this.errTextShow("Неверный формат ответа.", "danger", true)
                        } else {
                            if (resp.data.success) {
                                if (resp.data.data.toString().length > 0) {
                                    this.attachments = JSON.parse(resp.data.data)
                                } else {
                                    this.attachments = []

                                }
                            } else {
                                this.errTextShow(resp.data.response.toString(), "danger", true)
                            }
                        }
                        this.loadProcessing--
                    })
                    .catch(err => {
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")", "danger", true)
                        this.loadProcessing--
                    })
            },
            sortChanged(e) {
                this.sortBy = e.sortBy
                this.sortDesc = e.sortDesc
                this.loadRegistrationList()
            },
            buttonSearchClicked() {
                if (this.sortMode === 0)
                    this.searchEndDt = this.searchStartDt
                this.recordCurrentPageNumber = 1
                this.loadRegistrationList()
            },
            buttonAdvSearchShowClicked() {
                this.errTextHideModal()
                this.$refs['modal-search'].show()
            },
            buttonAdvSearchOkClicked() {
                this.errTextHideModal()

                if (this.searchStartDt === "") {
                    this.errTextShowModal("Введите дату начала.", "info")
                    return
                }
                if (this.searchEndDt === "") {
                    this.errTextShowModal("Введите дату окончания.", "info")
                    return
                }
                if (this.searchStartDt > this.searchEndDt) {
                    this.errTextShowModal("Дата начала не может быть позднее даты окончания.", "info")
                    return
                }

                this.sortMode = 1
                this.searchQuickFilter = ""

                this.loadRegistrationList()
                this.$refs['modal-search'].hide()
            },
            buttonAdvSearchCancelClicked() {
                this.sortMode = 0
                this.searchCompanyUid = 0
                this.searchResUid = ""
                this.searchStartDt = new Date().toISOString().substr(0, 10)
                this.searchRegistrationNum = ""
                this.searchSubscriber = ""
                this.searchPhoneNumber = ""
                this.searchAddress = ""
                this.searchRegistrationTypeUid = -1
                this.searchRegistrationStatusUid = -1
                this.recordCurrentPageNumber = 1
                this.$refs['modal-search'].hide()
                this.loadRegistrationList()
            },
            buttonAdvSearchCloseClicked() {
                this.$refs['modal-search'].hide()
            },
            buttonAddClicked() {
                this.errTextHide()
                this.recordUid = ""
                this.addEditTitle = "Добавление записи"
                this.editDocBlankUid = -1
                this.editRegistrationTypeUid = -1
                this.editSubscriber = ""
                this.editPhoneNumbers = ""
                this.editAddress = ""
                this.editDescription = ""
                this.fileDownloadCounter = 0

                this.editMode = 1

                if (this.userActionAccessCompany) {
                    this.$nextTick(() => {
                        this.$refs.selectEditCompany.$el.focus()
                    })
                } else if (this.userActionAccessRes) {
                    this.$nextTick(() => {
                        this.$refs.selectEditRes.$el.focus()
                    })
                } else {
                    this.$nextTick(() => {
                        this.$refs.selectEditRegistrationType.$el.focus()
                    })
                }
            },
            buttonRefreshClicked() {
                this.loadRegistrationList()
            },
            tableRowClicked(item) {
                this.errTextHide()
                this.recordUid = item.UID
                this.recordVersion = ""
                this.addEditTitle = ""
                this.editDocBlankUid = -1
                this.editCompanyUid = 0
                this.editResUid = ""
                this.editRegistrationTypeUid = -1
                this.editSubscriber = ""
                this.editAddress = ""
                this.editPhoneNumbers = ""
                this.editDescription = ""
                this.editRegistrationStatusUid = 0
                this.fileDownloadCounter = 0

                this.loadProcessing++
                axios.post("/ws/ws.svc/GetDocsNewSubscriberRegistration", {
                        'Session_UID': this.userData.Session_UID,
                        'F_UID': this.recordUid,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                        if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)) {
                            this.errTextShow("Неверный формат ответа.", "danger", true)
                        } else {
                            if (resp.data.success) {
                                if (resp.data.data.toString().length > 0) {
                                    let result = (JSON.parse(resp.data.data))[0]

                                    this.editCompanyUid = result.Company_UID ? parseInt(result.Company_UID.toString()) : 0
                                    this.editResUid = result.RES_UID.toString()
                                    this.editRegistrationTypeUid = parseInt(result.RegistrationType_UID.toString())
                                    this.editSubscriber = result.Subscriber.toString()
                                    this.editAddress = result.Address.toString()
                                    this.editPhoneNumbers = result.PhoneNumbers.toString()
                                    this.editDescription = result.Description.toString()
                                    this.editRegistrationStatusUid = parseInt(result.RegistrationStatus_UID.toString())
                                    this.editDocBlankUid = parseInt(result.DocBlank_UID.toString())
                                    this.recordVersion = result.RVV.toString()
                                    //this.editRegistrationStepUid = parseInt(result.NextStep_UID.toString())

                                    if (this.userActionAccessArray["edit"])
                                        this.addEditTitle = "Изменение записи: " + this.editSubscriber
                                    else
                                        this.addEditTitle = "Просмотр записи: " + this.editSubscriber
                                } else {
                                    this.errTextShow("Запись не найдена. Пожалуйста, обновите страницу.", "danger", true)
                                }
                            } else {
                                this.errTextShow(resp.data.response.toString(), "danger", true)
                            }
                        }

                        this.editMode = 1
                        this.loadProcessing--

                        if (this.userActionAccessCompany) {
                            this.$nextTick(() => {
                                this.$refs.selectEditCompany.$el.focus()
                            })
                        } else if (this.userActionAccessRes) {
                            this.$nextTick(() => {
                                this.$refs.selectEditRes.$el.focus()
                            })
                        } else {
                            this.$nextTick(() => {
                                this.$refs.selectEditRegistrationType.$el.focus()
                            })
                        }
                    })
                    .catch(err => {
                        this.editMode = 1
                        this.loadProcessing--
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")", "danger", true)
                    })
            },
            modalHidden() {
                this.$nextTick(() => {
                    this.$refs.inputQuickFilter.$el.focus()
                })
            },
            saveRecord() {
                this.errTextHide()

                if (this.userData.UserGroupUid === 1 && this.editCompanyUid === 0) {
                    this.errTextShow("Выберите РЭК.", "info", true)
                    return
                }
                if (this.userActionAccessRes && this.editResUid === "") {
                    this.errTextShow("Выберите РЭС.", "info", true)
                    return
                }
                if (this.editRegistrationTypeUid === -1) {
                    this.errTextShow("Выберите Вид регистрации.", "info", true)
                    return
                }
                if (this.editSubscriber.trim() === "") {
                    this.errTextShow("Введите Заявителя.", "info", true)
                    return
                }
                if (this.editPhoneNumbers.trim() === "") {
                    this.errTextShow("Введите Телефон(ы).", "info", true)
                    return
                }
                if (this.editAddress.trim() === "") {
                    this.errTextShow("Введите Адрес.", "info", true)
                    return
                }

                this.loadProcessing++
                axios.post("/ws/ws.svc/UpdateDocsNewSubscriberRegistration", {
                        'Session_UID': this.userData.Session_UID,
                        'R_UID': this.recordUid,
                        'R_Company_UID': this.editCompanyUid,
                        'R_RES_UID': this.editResUid,
                        'R_RegistrationType_UID': this.editRegistrationTypeUid,
                        'R_Subscriber': this.editSubscriber,
                        'R_Address': this.editAddress,
                        'R_PhoneNumbers': this.editPhoneNumbers,
                        'R_Description': this.editDescription,
                        'R_RS': this.editRegistrationStatusUid,
                        'R_RV': this.recordVersion,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                        if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)
                            || this.isUndefined(resp.data.data)) {
                            this.errTextShow("Неверный формат ответа.", "danger", true)
                        } else {
                            if (resp.data.success) {
                                this.showMessageRecordSaved()
                                if (resp.data.data.toString().length > 0) {
                                    let result = (JSON.parse(resp.data.data))
                                    this.recordUid = result.UID.toString() || ""
                                    this.recordVersion = result.RVV.toString() || ""
                                    this.editDocBlankUid = parseInt(result.DocBlank_UID.toString() || "-1")
                                    this.editRegistrationStepUid = parseInt(result.NextStep_UID.toString() || "-1")

                                    this.loadAttachments()
                                }
                            } else {
                                this.errTextShow(resp.data.response.toString(), "danger", true)
                            }
                        }

                        this.loadProcessing--
                    })
                    .catch(err => {
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")", "danger", true)
                        this.loadProcessing--
                    })
            },
            cancelRecord() {
                this.errTextHide()
                this.loadRegistrationList()
                this.editMode = 0
            },
            showMessageRecordSaved() {
                clearTimeout(this.editRecordSavedMessageTimer)
                this.editRecordSavedMessage = "Запись сохранена"
                this.editRecordSavedMessageTimer = setTimeout(() => {
                    this.editRecordSavedMessage = "";
                }, 5000);
            },
            generateBlank(lang) {
                //if (this.recordUid === "") return

                let routeData = this.$router.resolve({
                    path: '/blank-new-subscriber',
                    query: {
                        sessionUid: this.userData.Session_UID,
                        recordUid: this.recordUid,
                        docBlankUid: this.editDocBlankUid,
                        lang: lang
                    }
                })
                window.open(routeData.href, '_blank')
            },
            selectEditResChanged() {
                this.$refs.selectEditRegistrationType.$el.focus()
            },
            selectEditRegistrationTypeChanged() {
                this.$refs.inputEditSubscriber.$el.focus()
            },
            getDownloadStatus(p) {
                (p.status) ? this.fileDownloadCounter++ : this.fileDownloadCounter--
            },
        },
        computed: {
            getEditControlStatus: function () {
                return (!this.userActionAccessArray["edit"])
            },
        },
        watch: {
            loadProcessing: function () {
                this.$store.commit('set', ["showSpinner", this.loadProcessing > 0])
            },
        }
    }
</script>

<style scoped>
    .step-tab-container {
        display: flex;
        flex-wrap: wrap;
        -webkit-box-align: end;
        -ms-flex-align: end;
        align-items: flex-end;
    }

    .step-tab-item {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        flex-grow: 1;
        margin-right: 1rem;
    }

    .step-tab-item-label {
        color: #b5b5c3;
        flex: 1;
        display: flex;
        flex-direction: column;
        padding: 0 .5rem 2rem .5rem;
    }

    .step-tab-item-label h3 {
        font-size: 1.1rem;
        font-weight: 600;
        margin-bottom: .5rem;
    }

    .step-tab-item-label h3 span {
        font-size: 1.1rem;
        margin-right: .5rem;
    }

    .step-tab-item-bar {
        height: 4px;
        width: 100%;
        background-color: #ebedf3;
        position: relative;
    }

    .step-tab-item-bar::after {
        width: 100%;
        content: " ";
        position: absolute;
        top: 0;
        left: 0;
        height: 4px;
    }

    .step-tab-item.active > .step-tab-item-label {
        color: #3699ff !important;
    }

    .step-tab-item.active > .step-tab-item-label .step-tab-item-bar {
        background-color: #3699ff !important;
    }

    @media (max-width: 800px) {
        .step-tab-container {
            -webkit-box-orient: vertical;
            -webkit-box-direction: normal;
            -ms-flex-direction: column;
            flex-direction: column;
            -webkit-box-align: start;
            -ms-flex-align: start;
            align-items: flex-start;
        }

        .step-tab-item {
            -webkit-box-flex: 0;
            -ms-flex: 0 0 100%;
            flex: 0 0 100%;
            position: relative;
            width: 100%;
        }

        .step-tab-item-label {
            -webkit-box-pack: start;
            -ms-flex-pack: start;
            justify-content: flex-start;
            -webkit-box-flex: 0;
            -ms-flex: 0 0 100%;
            flex: 0 0 100%;
            padding: 1rem 0;
        }
    }
</style>